import React from 'react';
import { Link } from 'react-router-dom';
import AuthBackground from './AuthBackground';
import SignupForm from '../components/SignupForm';

// Full-page signup route. The form lives in <SignupForm/> so the landing-page
// modal can reuse it.
const Signup = () => {
    return (
        <div className="auth-viewport admin-theme gch-page">
            <AuthBackground />
            <main className="w-full flex flex-col flex-1 min-h-0 relative z-10">
                <div className="flex-shrink-0 flex items-center justify-between p-6 lg:px-10 lg:py-8">
                    <a href="/" className="flex items-center gap-3">
                        <img src="/transSmilesFlowFavicon.png" alt="SmilesFlow" className="h-8 w-8" />
                    </a>
                    <div className="text-sm gch-text-secondary">
                        Already have an account?{' '}
                        <Link to="/studio/login" className="font-semibold text-[#C45443] hover:opacity-80 transition-opacity">
                            Sign in
                        </Link>
                    </div>
                </div>
                <div className="flex-1 min-h-0 overflow-y-auto flex items-center justify-center p-6 lg:p-12" data-app-scroll-root>
                    <SignupForm showSignInLink={false} />
                </div>
            </main>
        </div>
    );
};

export default Signup;
